// extracted by mini-css-extract-plugin
module.exports = {"w1ulnsl8":"w1ulnsl8","w10stlkg":"w10stlkg","eztg1fj":"eztg1fj","levitate-eztg1fj":"levitate-eztg1fj","anhbzyq":"anhbzyq"};